<template>
    <div class="appointment-form" :class="'appointment-form-' + estate.network">
        <!-- <p>
            {{ trans('sentences.appointment') }}
        </p> -->

        <!-- <form @submit.prevent="sendLead"> -->
            <strong>
                {{ trans('labels.request_visit') }}
            </strong>
            <div class="appointment-type" :class="{ 'has-error': form.errors.has('type') }">
                <div class="form-check form-check-inline">
                    <input
                        v-model="form.type"
                        class="form-check-input"
                        type="radio"
                        id="appointment-type-1"
                        value="1"
                        @input="form.errors.clear('type')"
                    >
                    <label class="form-check-label" for="appointment-type-1">
                        <masked-image  src="/img/icons/in_agency.svg" ></masked-image> <span>{{ trans('labels.in_agency') }}</span>
                    </label>
                </div>

                <div 
                    class="form-check form-check-inline"
                    :class="{ disabled: ! estate.media.has_realistico }"
                >
                    <input
                        v-model="form.type"
                        class="form-check-input"
                        type="radio"
                        id="appointment-type-2"
                        value="2"
                        :disabled="! estate.media.has_realistico"
                        @input="form.errors.clear('type')"
                    >
                    <label class="form-check-label" for="appointment-type-2">
                        <masked-image  src="/img/icons/virtual_tour.svg" ></masked-image> <span>{{ trans('labels.remote') }}</span>
                    </label>
                </div>
                <error-span :error="form.errors.get('type')"></error-span>
            </div>

            <div class="calendar-dates" :class="{ 'has-error': form.errors.has('date') }">
                <strong>
                    {{ trans('labels.calendar_date') }}
                </strong>

                <my-carousel
                    :per-page-custom="[[0, 4], [992, 3], [1200, 4], [1440, 4]]" 
                    :pagination-enabled="false"
                    :scroll-per-page="true"
                    :navigation-enabled="true"
                    :navigation-next-label="'<span></span>'"
                    :navigation-prev-label="'<span></span>'"
                >
                    <slide v-for="date in dates" :key="date">
                        <div
                            class="calendar-date"
                            :class="{ 'is-active': form.date === date}"
                            @click="setDate(date)"
                        >
                            <div class="month">{{ month(date) }}</div>
                            <div class="day-number">{{ dayNumber(date) }}</div>
                            <div class="week-day">{{ weekDay(date) }}</div>
                        </div>
                    </slide>
                </my-carousel>

                <error-span :error="form.errors.get('date')"></error-span>
            </div>

            <strong>
                {{ trans('labels.time_range') }}
            </strong>
 
            <div class="time-ranges" :class="{ 'has-error': form.errors.has('time_range') }">
                <div
                    v-for="(range, index) in time_ranges"
                    :key="index"
                    class="time-range"
                    :class="{ 'is-active': form.time_range === range}"
                    @click="setTimeRange(range)"
                >
                    {{ range }}
                </div>
            </div>

            <error-span :error="form.errors.get('time_range')"></error-span>
            <div class="col alert">
                    <span v-html="trans('labels.disclaimer')"></span>
                </div>
            <strong>
                {{ trans('sentences.personal_data') }}
            </strong>

            <div class="container">
                <div class="row">
                    <div class="col pl-0 pr-small">
                        <my-input
                            v-model="form.first_name"
                            name="first_name"
                            :label="trans('labels.first_name')"
                            @input="form.errors.clear('first_name')"
                        />
                        <error-span :error="form.errors.get('first_name')"></error-span>
                    </div>

                    <div class="col pr-0 pl-small">
                        <my-input
                            v-model="form.last_name"
                            name="last_name"
                            :label="trans('labels.last_name')"
                            @input="form.errors.clear('last_name')"
                        />
                        <error-span :error="form.errors.get('last_name')"></error-span>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col pl-0 pr-small">
                        <my-input
                            v-model="form.email"
                            name="email"
                            type="email"
                            :label="trans('labels.email')"
                            @input="form.errors.clear('email')"
                        />
                        <error-span :error="form.errors.get('email')"></error-span>
                    </div>

                    <div class="col pr-0 pl-small">
                        <my-input
                            v-model="form.phone"
                            name="phone"
                            type="phone"
                            :label="trans('labels.phone')"
                            @input="form.errors.clear('phone')"
                        />
                        <error-span :error="form.errors.get('phone')"></error-span>
                    </div>
                </div>
            </div>

            <!-- <div class="privacy-policy" v-html="trans('agreements.privacy.label', { link: trans('agreements.privacy.link') })"></div> -->

            <privacy-checkbox
                v-model="form.privacy"
                name="privacy_appointment"
                id="lead-privacy-checkbox"
                :textPrivacy="lang.agreements.privacy.label"
                :langPrivacy="langPrivacy"
                modal="privacy"
            />
            <error-span :error="form.errors.get('privacy')" />

            <marketing-checkbox v-model="form.marketing" id="lead-marketing-appointment-checkbox" :lang="lang" />
            <marketing-agency-checkbox v-model="form.marketing_agency" id="lead-marketing-agency-appointment-checkbox" :lang="lang" />

            <div class="form-check">
                <tooltip :text="langPrivacy.privacy_agency">
                    <button
                        @click="onSubmit()"
                        class="btn btn-network m-0"
                        :class="'btn-network-' + estate.network"
                    >
                        {{ trans('labels.send') }}
                    </button>
                </tooltip>
            </div>
        <!-- </form> -->
    </div>
</template>

<script>
import moment from 'moment'

import MyCarousel from './MyCarousel'

import { capitalize } from '../helpers/strings'
import { Form } from '../classes/Form'

import MarketingCheckbox from './form/MarketingCheckbox'
import MarketingAgencyCheckbox from './form/MarketingAgencyCheckbox'
import PrivacyCheckbox from './form/PrivacyCheckbox'
import Tooltip from './Tooltip'

export default {
    components: {
        'marketing-checkbox': MarketingCheckbox,
        'marketing-agency-checkbox': MarketingAgencyCheckbox,
        'privacy-checkbox': PrivacyCheckbox,
        'my-carousel': MyCarousel,
        'tooltip': Tooltip,
    },

    props: {
        estate: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            available_dates_count: 17,

            form: new Form({
                agency_id: this.estate.agency.id,
                current_page: window.location.href,
                date: '',
                email: '',
                estate_id: this.estate.id,
                first_name: '',
                last_name: '',
                marketing: false,
                marketing_agency: false,
                message: '',
                phone: '',
                privacy: false,
                time_range: null,
                type: this.estate.media.has_realistico ? null : 1,
            }),

            minimum_notice: 3,

            rules: {
                date: ['required'],
                email: ['required', 'email'],
                first_name: ['required'],
                last_name: ['required'],
                phone: ['required', 'numeric', 'min:9'],
                privacy: ['required'],
                time_range: ['required'],
                type: ['required'],
            },

            time_ranges: [
                '9:00 - 12:00',
                '14:00 - 17:00',
                '17:00 - 19:00',
            ],
        }
    },

    computed: {
        dates() {
            let dates = []

            for (let i = this.minimum_notice; i <= this.available_dates_count; i++) {
                dates.push(moment().add(i, 'days').format('YYYY-MM-DD'))
            }

            return dates
        },

        lang() {
            return this.$root.lang.appointment_form
        },

        langPrivacy() {
            return this.$root.lang.privacy;
        },
    },

    methods: {
        dayNumber(day) {
            return moment(day).format('D')
        },

        month(day) {
            return moment(day).format('MMM')
        },

        onSubmit() {
            if (! this.form.validate(this.rules)) {
                return false
            }

            window.events.$emit('hideModal', { name: 'appointment' })
            window.events.$emit('hideModal', { name: 'appointment_estate' })

            this.form.post('/api/appointments')
                .then(({data}) => {
                    this.form.agency_id = this.estate.agency.id
                    this.form.estate_id = this.estate.id

                    flash(this.lang.flash.success)

                    if (typeof ga != 'undefined') {
                        let page_to_send = '/click-make-an-appointment/' + this.estate.agency.id + '/' + this.estate.id;	 	
                        ga('send', 'pageview', page_to_send);
                    }
                })
        },

        setDate(date) {
            this.form.date = date

            this.form.errors.clear('date')
        },

        setTimeRange(range) {
            this.form.time_range = range

            this.form.errors.clear('time_range')
        },

        weekDay(day) {
            return capitalize(moment(day).format('ddd'))
        },
    },
}
</script>